import { ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { KontaktdatenService } from '../../service/kontaktdaten/kontaktdaten.service';
import { Router } from '@angular/router';
import { WestnetzSidenavService } from '../../service/common/westnetz-sidenav/westnetz-sidenav.service';
import { MatTableDataSource } from '@angular/material/table';
import { take, takeWhile } from 'rxjs/operators';
import { SettingsKontaktdatenDetailComponent } from '../settings-kontaktdaten-detail/settings-kontaktdaten-detail.component';
import { Kontaktdaten } from '../../domain/model/kontaktdaten';

@Component({
    selector: 'redispatch-settings-kontaktdaten',
    templateUrl: './settings-kontaktdaten-page.component.html',
    styleUrls: [
        './settings-kontaktdaten-page.component.scss',
    ],
    standalone: false,
})
export class SettingsKontaktdatenPageComponent implements OnInit, OnDestroy {

    public kontaktdatenList = new MatTableDataSource<Kontaktdaten>();
    public componentDestroyed = false;

    private datasourceFilter = ((data: Kontaktdaten, filter: string) => {
        const joinedContacts = data.kontakte.map(contact => contact.data.toLowerCase() + contact.type.toLowerCase()).join('');
        const dataStr = data.name.toLowerCase() + data.adresse?.toLowerCase() + joinedContacts;
        return dataStr.indexOf(filter) != -1;
    });

    public westnetzSidenavService = inject(WestnetzSidenavService);
    private kontaktdatenService = inject(KontaktdatenService);
    private router = inject(Router);
    private changeDetectorRef = inject(ChangeDetectorRef);

    public columnsToDisplay = [
        'name',
        'adresse',
        'kontakte',
    ];

    ngOnInit() {
        this.kontaktdatenList.filterPredicate = this.datasourceFilter;

        this.reloadKontaktdaten();
        this.westnetzSidenavService.closeRightnav$
            .pipe(takeWhile(() => !this.componentDestroyed))
            .subscribe(() => {
                this.reloadKontaktdaten();
            });
    }

    ngOnDestroy(): void {
        this.componentDestroyed = true;
    }

    private reloadKontaktdaten() {
        this.kontaktdatenService.listKontaktdaten()
            .pipe(take(1))
            .subscribe(kb => {
                this.kontaktdatenList.data = kb;
                this.changeDetectorRef.markForCheck();
            });
    }

    public createKontaktdaten() {
        this.router.navigate([],
            {
                queryParams: { kontaktdaten: '' },
                queryParamsHandling: 'merge',
                skipLocationChange: true,
            });
        this.westnetzSidenavService.openRightnav(SettingsKontaktdatenDetailComponent);
    }

    public applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.kontaktdatenList.filter = filterValue.trim().toLowerCase();
    }

    public openKontaktdaten(kontaktdaten: Kontaktdaten) {
        this.router.navigate([],
            {
                queryParams: { kontaktdaten: kontaktdaten.id },
                queryParamsHandling: 'merge',
                skipLocationChange: true,
            });
        this.westnetzSidenavService.openRightnav(SettingsKontaktdatenDetailComponent);

    }
}
